/* 🤖 this file was generated by script */
export const wiconMoon01 = {
  name: 'moon_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22 15.84A10.46 10.46 0 018.16 2 10.46 10.46 0 1022 15.84z"/></svg>`,
};
